<div class="sidebar-wrapper follow-up" id="follow-up-sidebar">
  <p-sidebar
   styleClass="p-sidebar-md"
   dismissible="false"
   blockScroll="false"
   position="right"
   cache="false"
  [showCloseIcon]="false"
  [dismissible]="false"
  [(visible)]="isSidebarVisible"
  (onHide)="handleResetData()"
  baseZIndex="9">
    <div class="sidebar-container" #sidebarContainer>
      <div class="follow-up-sidepanel-wrapper">

        <!-- Sidebar header -->
        <div class="follow-up-sidepanel-header pr-20">
          <h3 class="follow-title">Follow-ups</h3>

          <div class="follow-up-header-ddl">
            <app-dropdown id="campaign-type" listId="campaign-type-list" scrollHeight="200px" theme="light"
              styleClass="markup-dropdown-wrapper" styleClassSelectedView="pl-0" styleClassValue="pl-0"
              styleClassDropdownList="markup-dropdown-list-wrapper" label="Type*" placeholder="Select vehicle"
              [value]="selectedFilter" [options]="vehicles" [isDropdownIconVisible]="true" [fontSize]="14"
              [listItemFontSize]="12" (appSelect)="handleVehicleSelect($event)">
            </app-dropdown>
          </div>

          <i id="sidebar-close-icon" class="fal fa-times sidebar-close-icon" (click)="handleCloseSidebar()"></i>
        </div>

        <!-- Sidebar content -->
        <div class="follow-up-sidepanel-body follow-up-accordion">
          <!-- Sidebar left -->
          <div class="follow-up-sidepanel-box-1 pr-2">
            <!-- Upcoming follow-up -->
            <p-accordion styleClass="upcoming-follow-up estimate-accordion with-right-chevron" [multiple]="true">
              <p-accordionTab [selected]="true">
                <!-- Follow-up header -->
                <p-header>
                  <h2 class="accordion-trigger text-uppercase font-bold font-14">
                    Upcoming follow-ups ({{upComingFollowUps?.length}})
                  </h2>
                </p-header>

                <!-- Follow-up empty screen -->
                <div class="accordian-empty-screen" *ngIf="!upComingFollowUps?.length">
                  There are no upcoming follow-ups for this vehicle
                </div>

                <!-- Follow-up list -->
                <div *ngFor="let followUp of upComingFollowUps; let i = index;">
                  <div class="inner-accordion">
                    <app-sidepanel-follow-up-campaign [isMarketingOptOutEnabled]="isMarketingOptOutEnabled"
                      [serverTime]="serverTime" [isScheduled]="true" [isAutomatedFollowUpEnabled]="isAutomatedFollowUpEnabled"
                      [isExpanded]="this.isUpcomingExpanded" id="sidepanel-upcoming-{{i}}"
                      [customer]="customer" [followUp]="followUp" (appFetchFollowUps)="fetchFollowUps()"
                      (openContactUpdateDialog)="openContactUpdateDialog()">
                    </app-sidepanel-follow-up-campaign>
                  </div>

                  <p *ngIf="isMarketingOptOutEnabled && followUp?.unsubscribeCount === followUp?.contacts?.length"
                    class="m-0 font-white bg-yellow flex-center-center blocked-label">
                    <i class="fal fa-exclamation-triangle pr-2"></i>
                    <span>Follow-up blocked</span>
                  </p>
                </div>
              </p-accordionTab>
            </p-accordion>

            <!-- Past follow-up -->
            <p-accordion styleClass="upcoming-follow-up estimate-accordion with-right-chevron" [multiple]="true">
              <p-accordionTab [selected]="true">
                <!-- Follow-up header -->
                <p-header>
                  <h2 class="accordion-trigger text-uppercase font-bold font-14">
                    Past follow-ups ({{pastFollowUps?.length}})
                  </h2>
                </p-header>

                <!-- Follow-up empty screen -->
                <div class="accordian-empty-screen" *ngIf="!pastFollowUps?.length">
                  There are no past follow-ups for this vehicle
                </div>

                <!-- Follow-up list -->
                <div *ngFor="let followUp of pastFollowUps; let i = index;">
                  <div class="inner-accordion">
                    <app-sidepanel-follow-up-campaign [isMarketingOptOutEnabled]="isMarketingOptOutEnabled"
                      [serverTime]="serverTime" [isScheduled]="true" [isExpanded]="this.isUpcomingExpanded" id="sidepanel-past-{{i}}"
                      [customer]="customer" [isAutomatedFollowUpEnabled]="isAutomatedFollowUpEnabled" [followUp]="followUp" [isPastFollowup]="true"
                      (appFetchFollowUps)="fetchFollowUps()" (openContactUpdateDialog)="openContactUpdateDialog()">
                    </app-sidepanel-follow-up-campaign>
                  </div>
                </div>

              </p-accordionTab>
            </p-accordion>
          </div>

          <!-- Sidebar right -->
          <div class="follow-up-sidepanel-box-2 pr-20">
            <!-- Recommended follow-up -->
            <p-accordion *ngIf="hasRecommendedFollowup" styleClass="upcoming-follow-up estimate-accordion with-right-chevron" [multiple]="true">
              <p-accordionTab [selected]="true">
                <!-- Follow-up header -->
                <p-header>
                  <h2 class="accordion-trigger text-uppercase font-bold font-14">
                    RECOMMENDED FOLLOW-UPS ({{recommendedFollowUps?.length}})
                  </h2>
                </p-header>

                <!-- Follow-up empty screen -->
                <div class="accordian-empty-screen" *ngIf="!recommendedFollowUps?.length">
                  There are no recommended follow-ups for this vehicle
                </div>

                <!-- Follow-up list -->
                <div class="inner-accordion" *ngFor="let followUp of _recommendedFollowUps; let i = index;">
                  <app-sidepanel-follow-up-campaign [isMarketingOptOutEnabled]="isMarketingOptOutEnabled"
                    [serverTime]="serverTime" [isExpanded]="isEligibleExpanded" [customer]="customer"
                    [followUp]="followUp" (appFetchFollowUps)="fetchFollowUps()" id="recommended-{{i}}"
                    (openContactUpdateDialog)="openContactUpdateDialog()">
                  </app-sidepanel-follow-up-campaign>
                </div>

                <p *ngIf="recommendedFollowUps?.length && recommendedFollowUps?.length > _recommendedFollowUps?.length"
                  class="show-more-less-btn flex-center-center font-600 font-12 m-0 pointer p-1 mt-2"
                  (click)="handleLoadMore('recommendedFollowUps')">
                  Show more
                </p>
              </p-accordionTab>
            </p-accordion>

            <!-- Eligible Follow-up -->
            <p-accordion styleClass="upcoming-follow-up estimate-accordion with-right-chevron" [multiple]="true">
              <p-accordionTab [selected]="true">
                <!-- Follow-up header -->
                <p-header>
                  <h2 class="accordion-trigger text-uppercase font-bold font-14">
                    ELIGIBLE FOLLOW-UPS ({{eligibleFollowUps?.length}})
                  </h2>
                </p-header>

                <!-- Follow-up empty screen -->
                <div class="accordian-empty-screen" *ngIf="!eligibleFollowUps?.length">
                  There are no eligible follow-ups for this vehicle
                </div>

                <!-- Follow-up list -->
                <div class="inner-accordion" *ngFor="let followUp of _eligibleFollowUps; let i = index;"  [ngClass]="{'tooltip-alignment': i === 0}">
                  <app-sidepanel-follow-up-campaign [isMarketingOptOutEnabled]="isMarketingOptOutEnabled"
                    [serverTime]="serverTime" [isExpanded]="isEligibleExpanded" [customer]="customer"
                    [followUp]="followUp" (appFetchFollowUps)="fetchFollowUps()" id="eligible-{{i}}"
                    (openContactUpdateDialog)="openContactUpdateDialog()">
                  </app-sidepanel-follow-up-campaign>
                </div>

                <p *ngIf="eligibleFollowUps?.length && eligibleFollowUps?.length > _eligibleFollowUps?.length"
                  class="show-more-less-btn flex-center-center font-600 font-12 m-0 pointer p-1 mt-2"
                  (click)="handleLoadMore('eligibleFollowUps')">
                  Show more
                </p>
              </p-accordionTab>
            </p-accordion>
          </div>
        </div>
      </div>
    </div>
  </p-sidebar>
</div>
